// PlinkoEngine.tsx
import { useEffect, useRef, useCallback, useState } from "react";
import Matter, {
  Engine,
  Render,
  Bodies,
  Composite,
  Events,
  Runner,
} from "matter-js";

// import Matter, { Engine, Render, Runner, Bodies, Composite, Events, Body } from 'matter-js';

const betAmount = 10;
// const rowCount = 16;
const balance = 1000;
let WIDTH = 720; // 720;
let HEIGHT = 550; // 550
// const PADDING_X = 56;
// const PADDING_TOP = 40;
// const PADDING_BOTTOM = 50;
const PADDING_X = 52;
const PADDING_TOP = 36; // 36
const PADDING_BOTTOM = 50;
const gridColors = {};

const PlinkoEngineNew = ({
  ballColor,
  rowCount,
  resultantData,
  payoutTable,
  risk,
  hitAudio,
  audioVolume,
  startResolve,
  setStartResolve,
  setGridColor,
  audioAllowModal,
}) => {
  const canvasRef = useRef(null);
  const engineRef = useRef();
  const renderRef = useRef();
  const runnerRef = useRef();
  const pinsRef = useRef([]);
  const wallsRef = useRef([]);
  const pinsLastRowXCoordsRef = useRef([]);
  const sensorRef = useRef();
  const ballsRef = useRef({});

 

  const [storeObj, setStoreObj] = useState([]);
  let gridHeight = 40;
  let gridWidth = (WIDTH / rowCount) * 0.84; // * 0.84 // -10 to decrease width
  const gridLines = [];

  // Constants

  const ballFrictions = {
    friction: 0.5,
    frictionAirByRowCount: {
      8: 0.0395,
      9: 0.041,
      10: 0.038,
      11: 0.0355,
      12: 0.0414,
      13: 0.0437,
      14: 0.0401,
      15: 0.0418,
      16: 0.0364,
    },
  };

  const PIN_CATEGORY = 0x0001;
  const BALL_CATEGORY = 0x0002;
  let startAt = 0;

  const pinDistanceX = (rowCount) =>
    (WIDTH - PADDING_X * 2) / (3 + rowCount - 1 - 1);

  const pinRadius = (rowCount) => (24 - rowCount) / 2;

  const placePinsAndWalls = useCallback(() => {
    const engine = engineRef.current;

    // if (!engine) return;

    if (pinsRef.current.length > 0) {
      // Composite.remove(engine.world, pinsRef.current);
      pinsRef.current = [];
    }
    if (wallsRef.current.length > 0) {
      // Composite.remove(engine.world, wallsRef.current);
      wallsRef.current = [];
    }
    pinsLastRowXCoordsRef.current = [];

    for (let row = 0; row < rowCount; row++) {
      const rowY =
        PADDING_TOP +
        ((HEIGHT - PADDING_TOP - PADDING_BOTTOM) / (rowCount - 1)) * row;

      const rowPaddingX =
        PADDING_X + ((rowCount - 1 - row) * pinDistanceX(rowCount)) / 2;

      for (let col = 0; col < 3 + row; col++) {
        const colX =
          rowPaddingX + ((WIDTH - rowPaddingX * 2) / (3 + row - 1)) * col;
        const pin = Matter.Bodies.circle(colX, rowY, pinRadius(rowCount), {
          isStatic: true,
          label: `pin`,
          render: { fillStyle: "#ffffff" },
          collisionFilter: {
            category: PIN_CATEGORY,
            mask: BALL_CATEGORY,
          },
        });
        pinsRef.current.push(pin);

        if (row === rowCount - 1) {
          pinsLastRowXCoordsRef.current.push(colX);
        }
      }
    }

    Composite.add(engine.world, pinsRef.current);

    // Walls
    const firstPinX = pinsRef.current[0]?.position.x ?? 0;
    const lastPinX = pinsLastRowXCoordsRef.current[0];
    const angle = Math.atan2(
      firstPinX - lastPinX,
      HEIGHT - PADDING_TOP - PADDING_BOTTOM
    );
    const leftWallX =
      firstPinX - (firstPinX - lastPinX) / 2 - pinDistanceX(rowCount) * 0.25;

    const leftWall = Matter.Bodies.rectangle(leftWallX, HEIGHT / 2, 0, HEIGHT, {
      isStatic: true,
      angle,
      render: { visible: false },
    });
    const rightWall = Matter.Bodies.rectangle(
      WIDTH - leftWallX,
      HEIGHT / 2,
      0,
      HEIGHT,
      { isStatic: true, angle: -angle, render: { visible: false } }
    );
    wallsRef.current.push(leftWall, rightWall);

    Composite.add(engine.world, wallsRef.current);
  }, [rowCount]);

  const placeMul = useCallback(() => {
    const engine = engineRef.current;
    if (!engine) return;

    const multiplierSize = 20; // Size of each multiplier
    const offsetY = 20; // Distance from bottom

    // Dynamically calculate pin positions across the canvas
    const pinGap = WIDTH / (rowCount - 1);
    const pinsX = Array.from({ length: rowCount }, (_, i) => i * pinGap);

    // Multipliers go between pins
    const multipliers = Array.from({ length: rowCount }, (_, i) => ({
      x: (pinsX[i] + pinsX[i + 1]) / 2,
      label: `multiplier-${i + 1}`,
      // img: `path_to_image_${i + 1}.png`, // Replace as needed
    }));

    const y = HEIGHT - multiplierSize / 2 - offsetY;

    const multiplierBodies = multipliers.map((mul) =>
      Bodies.rectangle(mul.x - 10, y, multiplierSize, multiplierSize, {
        label: mul.label,
        isStatic: true,
        render: {
          fillStyle: "#FFD700",
          sprite: {
            // texture: mul.img || '',
            xScale: 1,
            yScale: 1,
          },
        },
      })
    );

    Composite.add(engine.world, multiplierBodies);
  }, [rowCount]);

  const handleBallEnterBin = useCallback(
    (ball) => {
      const binIndex = pinsLastRowXCoordsRef.current.findLastIndex(
        (x) => x < ball.position.x
      );
      if (
        binIndex !== -1 &&
        binIndex < pinsLastRowXCoordsRef.current.length - 1
      ) {
        // console.log(142, ball)
        const ballBetAmount = ballsRef.current[ball.id] ?? 0;
        const multiplier = 1; // TODO: You should get it based on binPayouts
        const payoutValue = ballBetAmount * multiplier;
        const profit = payoutValue - ballBetAmount;

        // onWinRecordAdd({
        //   id: uuidv4(),
        //   betAmount: ballBetAmount,
        //   rowCount,
        //   binIndex,
        //   payout: {
        //     multiplier,
        //     value: payoutValue,
        //   },
        //   profit,
        // });
        // onTotalProfitUpdate(profit);
        // onBalanceUpdate(balance + payoutValue);
      }

      // Composite.remove(engineRef.current!.world, ball);
      delete ballsRef.current[ball.id];
    },
    [balance, rowCount]
  );

  useEffect(() => {
    if (rowCount >= 8 && rowCount <= 10) {
      WIDTH = 720;
      HEIGHT = 550;
    } else if (rowCount >= 11 && rowCount <= 15) {
      WIDTH = 650;
      HEIGHT = 520;
    } else {
      WIDTH = 610;
      HEIGHT = 550;
    }
  }, [rowCount]);

  useEffect(() => {
   
   
    if (resultantData) {
      // console.log("dropBall", resultantData)
      dropBall();
    }
  }, [resultantData]);

  useEffect(() => {
    resizeHandler();
    window.addEventListener("resize", resizeHandler);
    return () =>
      window.removeEventListener("resize", () => {
        resizeHandler();
      });
  }, []);

  const resizeHandler = () => {
    let responsiveWidth = window.innerWidth;
    if (responsiveWidth >= 1200) {
      // Desktop

      // WIDTH = 760;
      // HEIGHT =  550 //660;
      gridWidth = (WIDTH / rowCount) * 0.5; // 0.5
      // gridHeight = gridWidth - 5;
    } else if (responsiveWidth <= 1199 && responsiveWidth > 992) {
      // Desktop
      // WIDTH = 760;
      // HEIGHT = 760 * 88/100
      gridWidth = (WIDTH / rowCount) * 0.5;
      // gridHeight = gridWidth - 5;
    } else if (responsiveWidth <= 991 && responsiveWidth > 768) {
      // Laptop
      // WIDTH = 760;
      // HEIGHT = 760 * 88/100;
      gridWidth = (WIDTH / rowCount) * 0.5;
      // gridHeight = gridWidth - 5;
    } else if (responsiveWidth <= 768 && responsiveWidth > 576) {
      // Tablet
      // WIDTH = 760;
      // HEIGHT = 760 * 88/100;
      gridWidth = (WIDTH / rowCount) * 0.5;
      // gridHeight = gridWidth - 5;
    } else if (responsiveWidth <= 576) {
      // Mobile
      // WIDTH = 540;
      // HEIGHT = 408 // * 88/100;
      gridWidth = (WIDTH / rowCount) * 0.5;
      // gridHeight = gridWidth - 5;
    }
  };

  // useEffect(() => {
  //   console.log(422, startResolve)
  // }, [startResolve])

  const dropBall = () => {
    const engine = engineRef.current;
    const pinGap = WIDTH / (rowCount - 1);
    const minBallX = WIDTH / 2 - pinRadius(rowCount) * 3 + pinGap;
    const maxBallX = WIDTH / 2 - pinRadius(rowCount) * 3 - pinGap + pinGap / 2;

    let rangeMultiplier = Math.random() * (1.7 - 0.5) + 0.5; // for 11 rows
    // let rangeMultiplier = Math.random() * (1.7 - 0.8) + 0.8; // for 12 rows
    // for new 8 = Math.random() * (1.6 - 0.8) + 0.8 width 720 550
    // for new 9 = Math.random() * (1.4 - 0.5) + 0.5 width 720 550
    // for new 10 =  Math.random() * (1.4 - 0.4) + 0.4 width 720 550
    // for new 11 = (1.1 - 0.2) + 0.2 width 650 520
    //  for new 12  = Math.random() * (1.1 - 0.2) + 0.2  width 650 520
    // for 13 Math.random() * (2.5 - 0.1) + 0.1 width 650 520
    // for 14 Math.random() * (2.5 - 0.1) + 0.1 width 650 520
    // for 15 Math.random() * (2.5 - 0) + 0 width 650 520
    // for 16 Math.random() * (1.7 - 0.5) + 0.5 width 610 550

    //  console.log({rangeMultiplier})

    if (rowCount == 8) {
      rangeMultiplier = 1.6;
    }

    const ballOffsetRangeX = pinDistanceX(rowCount) * rangeMultiplier;
    const radius = pinRadius(rowCount) * 2;

    engine.world.gravity.y = 1;

    const startAt = 
   resultantData?.startX
      ? resultantData.startX
      : Math.random() *
          (WIDTH / 2 + ballOffsetRangeX - (WIDTH / 2 - ballOffsetRangeX)) +
        (WIDTH / 2 - ballOffsetRangeX);

        // console.log(resultantData, startAt)
    const ball = Matter.Bodies.circle(startAt, 0, radius, {
      label: "ball",
      // restitution: 0.8,

      restitution: 0.8, // no bounce
      // friction: 0,        // no ground friction
      // frictionAir: 0,

      friction: ballFrictions.friction,
      frictionAir: ballFrictions.frictionAirByRowCount[rowCount],
      collisionFilter: {
        category: BALL_CATEGORY,
        mask: PIN_CATEGORY,
      },
      render: { fillStyle: ballColor ? ballColor : "#ffffff" },
    });
    ball.initialPosition = { x: startAt };

    Composite.add(engine.world, ball);
    ballsRef.current[ball.id] = betAmount;

    let isProcessed = false;

    const processedBallIds = new Set();

  

    // Define the handler separately
    const collisionHandler = (event) => {
      event.pairs.forEach((pair) => {
        const { bodyA, bodyB } = pair;
      
        const ballBody = [bodyA, bodyB].find((body) => body.label === "ball");
        const grid = [bodyA, bodyB].find((body) =>
          body.label?.startsWith("grid")
        );

        const pin = [bodyA, bodyB].find((body) => body.label === "pin");

        const velocity = Matter.Vector.magnitude(ball.velocity);

       
        if (
          ballBody &&
          grid &&
          !isProcessed &&
          !processedBallIds.has(ballBody.id)
        ) {
          processedBallIds.add(ballBody.id);
          isProcessed = true;

         

          Matter.Body.translate(grid, { x: 0, y: 10 });
          // ballBody.render.opacity = 0.6;

         
          Matter.World.remove(engine.world, ballBody);
          // setStoreObj((prev) => {
          //   const newStartX = Number(ballBody.initialPosition.x);

          //   const exists = prev.some(
          //     (item) =>
          //       item.result === grid.label && Number(item.startX) === newStartX
          //   );

          //   if (!exists) {
          //     return [
          //       ...prev,
          //       { result: grid.label, startX: newStartX, rows: rowCount },
          //     ];
          //   }

          //   return prev;
          // });

          playSound(hitAudio, true);
          setTimeout(() => {
            

            Matter.Body.translate(grid, { x: 0, y: -10 });
            // console.log(grid)
            isProcessed = false;
            setTimeout(() => {
              Matter.World.remove(engine.world, ballBody);
              processedBallIds.delete(ballBody.id);
              ballBody.render.opacity = 0;
             
            setStartResolve({ bool: true, numOf: startResolve.numOf + 1 });
            }, 1000);

            // Events.off(engine, "collisionStart", collisionHandler);

            
          }, 300);
        

          setGridColor(gridColors);

          // ✅ After processing, remove this handler
          // Events.off(engine, "collisionStart", collisionHandler);
        }

        if (ballBody && pin) { //  
          let scale = 1.5;
          let opacity = 0.7;

          const updateGlow = () => {
            pin.render.strokeStyle = `rgba(255, 20, 147, ${opacity})`;
            pin.render.lineWidth = scale * 8;

            scale += 0.1;
            opacity -= 0.08;

            if (opacity > 0) {
              requestAnimationFrame(updateGlow);
            } else {
              pin.render.strokeStyle = "transparent";
              pin.render.lineWidth = 0;
            }
          };

          updateGlow();
        }
      });
    };

    // Attach the event listener
    Events.on(engine, "collisionStart", collisionHandler);
  };



  const triggerMultiplierBounce = (multiplierBody) => {
 
    if (!multiplierBody) return;

    // Set a squish value
    multiplierBody.render.userData = { squish: 0.8, time: 0 }; // scale Y to 80%
  };

  useEffect(() => {
    if (!canvasRef.current) return;

    const engine = Engine.create({ timing: { timeScale: 1 } });
    const render = Render.create({
      engine,
      canvas: canvasRef.current,
      options: {
        width: WIDTH,
        height: HEIGHT + gridHeight,
        background: "#181d29",
        wireframes: false,
      },
    });
    const runner = Runner.create();

    engineRef.current = engine;
    renderRef.current = render;
    runnerRef.current = runner;

    placePinsAndWalls();
 
    if ((risk, rowCount, payoutTable[rowCount])) {
      drawGridNumbers(risk, rowCount, payoutTable[rowCount]);
    }

    //  placeMul();

    const sensor = Matter.Bodies.rectangle(WIDTH / 2, HEIGHT, WIDTH, 5, {
      isStatic: true,
      isSensor: true,
      label: "sensor",
      render: { visible: true },
    });
    sensorRef.current = sensor;

    // Composite.add(engine.world, sensor);

    Render.run(render);
    Runner.run(runner, engine);

    return () => {
      Render.stop(render);
      Runner.stop(runner);
      Composite.clear(engine.world);
    };
  }, [rowCount, risk]);

  const audioRef = useRef(null);

  useEffect(() => {

    if(audioVolume) {
      if (audioRef.current) {
        audioRef.current.volume = audioVolume;
      }
    }
  }, [audioVolume])

  // Play sound
  const playSound = (url, run) => {
    
    if (audioAllowModal.allow && url) {
      if (!audioRef.current) {
        console.log("play", url, run, audioAllowModal.allow)
        audioRef.current = new Audio(url);
        audioRef.current.loop = true;
        audioRef.current.play().catch((e) => console.error(e));
      }
      if (!run) {
        if (audioRef.current) {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          audioRef.current = null;
        }
      }
      if (audioRef.current) {
        audioRef.current.volume = audioVolume / 100;
      }
      // Set initial volume
    }
  };
  const [stop, setStop] = useState(true);

  useEffect(() => {
    // setStop(false);
    // setTimeout(() => {
    //   setStop(true);
    // }, 1000);
  }, [risk]);

  useEffect(() => {
 
    if (renderRef.current  && rowCount) { 
      // && payoutTable[rowCount]
      const render = renderRef.current;
      const handleAfterRender = () => {
        // if (payoutTable && payoutTable[rowCount]) {
        //  console.log("payoutTable", payoutTable)
        if (stop && rowCount) {
          drawGridNumbers(risk, rowCount, payoutTable[rowCount]); // payoutTable[rowCount]
        }

        // }
      };
      // Events.off(render, "afterRender", handleAfterRender);
      if (!stop) {
        // Events.off(renderRef.current, "afterRender", handleAfterRender);
      } else {
        Events.on(renderRef.current, "afterRender", handleAfterRender);
      }
    }
  }, [renderRef.current, risk, rowCount, payoutTable, stop]);

  useEffect(() => {
    const engine = engineRef.current;

    const boxes = calculateBoxesWithMargin(WIDTH, PADDING_X, 8, rowCount + 1);

   
    for (let i = 0; i <= rowCount; i++) {
      const x = i * gridWidth + gridWidth / 2;
      const y = HEIGHT - gridHeight / 2 + 0; // Adjust Y position
      // console.log(564, i, x, boxes[i], gridWidth)
      const grid = Bodies.rectangle(
        boxes[i].x, // x
        y,
        boxes[i].width, //gridWidth,
        gridHeight, // Apply reduced height
        {
          isStatic: true,
          label: `grid_${i}`,
          render: {
            fillStyle: "transparent",
            lineWidth: 0,
            strokeStyle: "transparent",
          },
        }
      );

      gridLines.push(grid);
    }

    Composite.add(engine?.world, gridLines);
  }, [rowCount]);
  const canvasWidth = WIDTH;
  const padding = PADDING_X;
  // const margin = 20;
  const numberOfBoxes = 16;

  function calculateBoxesWithMargin(mainWidth, padding, margin, n) {
    const availableWidth = mainWidth - 2 * padding;
    const totalMargin = (n - 1) * margin;
    const boxWidth = (availableWidth - totalMargin) / n;

    const boxes = Array.from({ length: n }, (_, i) => ({
      x: padding + i * (boxWidth + margin),
      width: boxWidth,
    }));

    return boxes;
  }

  // Example usage

  const drawGridNumbers = (riskFactor, count, payOut) => {
    const boxes = calculateBoxesWithMargin(WIDTH, PADDING_X, 8, rowCount + 1);

    const ctx = renderRef.current.context;
    const margin = 8; // 2// gridWidth/rowCount * 1.2; // Margin around each number box

    const rowHeight = 0; // gridHeight * 0.7 + margin * 2; // Adjust height considering margin

    // Group gridLines by rows (assuming they are in order)
    const rows = {};

    gridLines.forEach((grid) => {
      const rowIndex = Math.floor(grid.position.y / rowHeight);
      if (!rows[rowIndex]) rows[rowIndex] = [];
      rows[rowIndex].push(grid);
    });

    // console.log(WIDTH, PADDING_X, 28 * rowCount)
    // Iterate through rows and apply gradient row-wise
    Object.values(rows).forEach((row, index) => {
      if (row.length === 0) return;

      // Get the first and last grid in the row to define the gradient
      const firstGrid = row[0];
      const lastGrid = row[row.length - 1];

      const gradient = ctx.createLinearGradient(
        firstGrid.position.x - gridWidth / 2,
        firstGrid.position.y - rowHeight / 2,
        lastGrid.position.x + gridWidth / 2,
        firstGrid.position.y + rowHeight / 2
      );

      gradient.addColorStop(0, "red");
      gradient.addColorStop(0.35, "orange");
      gradient.addColorStop(0.45, "yellow");
      gradient.addColorStop(0.45, "yellow");
      gradient.addColorStop(0.65, "orange");
      gradient.addColorStop(1, "red");

      // Apply the same gradient to all grids in this row
      row.forEach((grid, index) => {
        // const textX = 52 + index * 10;
        //const textY = grid.position.y - gridHeight * 0.05;
        const textX = grid.position.x + 10;
      
        const textY = grid.position.y - gridHeight * 0.05; // Adjust text Y position
       

        ctx.fillStyle = gradient;

        ctx.fillRect(
          boxes ? boxes[index]?.x : textX + sta / 2 / rowCount,
          textY - gridHeight * 0.3 + 20, // Decrease background height
          2,
          2
          // gridWidth - 2 * margin,
          // gridHeight * 0.5 // **Reduce height of gradient fill**
        );

        // const rectX = textX - gridWidth / 2 + margin / 2; // Add margin
        const rectY = textY - gridHeight * 0.25 + 1 + margin / 2; // Add margin
        // const rectWidth = (gridWidth*0.8) - margin; // -margin Reduce width for spacing
        const rectHeight = gridHeight * 0.6; //- margin; // Reduce height for spacing

        const borderRadius = 5;

        ctx.beginPath();
        let sta = gridWidth * rowCount;
        let rectWidth = boxes ? boxes[0]?.width : gridWidth * 1; // Even narrower boxes (adjust as needed)
        let rectX = boxes ? boxes[index]?.x : textX + sta / 2 / rowCount; // Correctly center the box
        
        // Object.assign(newObj, {[index]: rectX})
      
        // if(rowCount >= 14) {
        //    sta = gridWidth*rowCount
        //    rectWidth =  gridWidth * 0.8; // Even narrower boxes (adjust as needed)

        //     rectX = textX +  (sta/2)/rowCount; // Correctly center the box

        // } else {
        //   sta = gridWidth*rowCount
        //   rectWidth = gridWidth * 0.8; // Even narrower boxes (adjust as needed)
        //   rectX = textX;
        // }

        ctx.moveTo(rectX + borderRadius, rectY);
        ctx.lineTo(rectX + rectWidth - borderRadius, rectY);
        ctx.quadraticCurveTo(
          rectX + rectWidth,
          rectY,
          rectX + rectWidth,
          rectY + borderRadius
        );
        ctx.lineTo(rectX + rectWidth, rectY + rectHeight - borderRadius);
        ctx.quadraticCurveTo(
          rectX + rectWidth,
          rectY + rectHeight,
          rectX + rectWidth - borderRadius,
          rectY + rectHeight
        );
        ctx.lineTo(rectX + borderRadius, rectY + rectHeight);
        ctx.quadraticCurveTo(
          rectX,
          rectY + rectHeight,
          rectX,
          rectY + rectHeight - borderRadius
        );
        ctx.lineTo(rectX, rectY + borderRadius);
        ctx.quadraticCurveTo(rectX, rectY, rectX + borderRadius, rectY);
        ctx.closePath();
        ctx.fill(); // Fill the rounded rectangle

        setTimeout(() => {
          const sampleX = textX;
          const sampleY = textY - gridHeight * 0.3 + 20 + gridHeight * 0.25;

          const pixelData = ctx.getImageData(sampleX, sampleY, 1, 1).data;
          const color = `rgba(${pixelData[0]}, ${pixelData[1]}, ${
            pixelData[2]
          }, ${pixelData[3] / 255})`;

          gridColors[index] = color; // Store color for this grid index
        }, 0); // Let browser paint first

        // Draw number text
        ctx.label = `multiplier_${index}`;
        ctx.font = `bold ${rowCount > 11 ? 8 : 10}px 'Outfit', sans-serif`;
        ctx.fillStyle = "white";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.shadowColor = "rgba(0, 0, 0, 0.5)";
        ctx.shadowBlur = 4;
        ctx.shadowOffsetX = 2;
        ctx.shadowOffsetY = 2;
        // if (payoutTable[Number(formData?.rows)]) {

        if (payoutTable[count]) {
          ctx.fillText(
            `${payOut[index]}x`,
            rectX + rectWidth / 2, //boxes[index]?.x + 10,
            textY + rectHeight / 3 // /4
          );
        } else {
          ctx.fillText(
            `${index}x`,
            rectX + rectWidth / 2, // boxes[index]?.x +10 ,
            textY + rectHeight / 2 // Adjust text alignment to center
          );
         }
      });
    });
  };
  

  return (
    <div className="" style={{ width: "100%", position: "relative" }}>
         {/* <button className="text-white" onClick={() => {
        setTimeout(() => {
          let i = 0;
          let interval = setInterval(() => {
            if (i == 3) {
              clearInterval(interval);
              interval = undefined;
            }
            i++;

            dropBall(i);
          }, 400);
        }, 1000);
      }} > check </button>   */}
      <canvas
        ref={canvasRef}
        width={WIDTH}
        height={HEIGHT + 15}
        style={{ width: "100%", height: "100%", display: "block" }}
      />
    </div>
  );
};

export default PlinkoEngineNew;
